// extracted by mini-css-extract-plugin
module.exports = {"drawerHeader":"school-main_drawerHeader__2ppIe","drawer":"school-main_drawer__gRO1N","backButton":"school-main_backButton__2lXMR"};